import React from 'react';
import { getComponent } from './registry';
import { isVerticalKey, VerticalWidgetShell } from './verticalRegistry.jsx';

const DEFAULT_THEME = {
  primary: 'var(--color-primary, #3b82f6)',
  bg: 'var(--color-bg-secondary, #fafafa)',
  text: 'var(--color-text, #1a1d29)',
};

const BARE_VERTICAL_PREFIXES = [
  'vertical:transport.seat_map.',
  'vertical:transport.checkout.',
  'vertical:transport.hold_timer.',
  'vertical:transport.ticket_qr.',
];

function isBareVertical(componentKey) {
  return BARE_VERTICAL_PREFIXES.some((prefix) => componentKey.startsWith(prefix));
}

export default function UiPartRenderer({ part, onAction, disabled, dir, locale = 'en', theme }) {
  if (!part) return null;
  if (part.component === 'user_gate_bar') return null;

  const componentKey = part.component;
  const platformTheme = theme || DEFAULT_THEME;

  if (isVerticalKey(componentKey)) {
    const bareClass = isBareVertical(componentKey) ? ' ui-part--bare' : '';
    return (
      <div className={`ui-part${bareClass}`} data-part-id={part.part_id} dir={dir}>
        <VerticalWidgetShell
          keyName={componentKey}
          data={part.props || {}}
          onAction={(payload) => {
            const actionDef = (part.actions || []).find((a) => a.id === payload?.action);
            const actionId = payload?.action || payload?.actionId;
            const defaultMode =
              actionId === 'seat.toggle' || actionId === 'form.submit' || actionId === 'stepper.change'
                ? 'patch'
                : 'turn';
            onAction?.({
              actionId,
              mode: actionDef?.mode || payload?.mode || defaultMode,
              payload: payload,
              partId: part.part_id,
            });
          }}
          theme={platformTheme}
          locale={locale}
          disabled={disabled}
          dir={dir}
          partId={part.part_id}
          actions={part.actions || []}
        />
      </div>
    );
  }

  const Component = getComponent(componentKey, part.version);
  if (!Component) {
    return (
      <div className="ui-part-unknown" dir={dir}>
        Unknown component: {componentKey}@{part.version}
      </div>
    );
  }
  const mireaClass = componentKey.startsWith('retake_') || componentKey === 'campus_map'
    ? ' ui-part--mirea'
    : '';
  return (
    <div className={`ui-part${mireaClass}`} data-part-id={part.part_id} dir={dir}>
      <Component
        props={part.props || {}}
        actions={part.actions || []}
        partId={part.part_id}
        onAction={onAction}
        disabled={disabled}
        dir={dir}
      />
    </div>
  );
}
